import { useState, useRef } from "react"
import nodeApiService from "../../services/nodeApiService"
import windowService from "../../services/WindowService"

export const useContactAction = (gallery) => {
  const recaptchaRef = useRef()
  const [form, setForm] = useState({
    email: "",
    firstname: "",
    lastname: "",
    body: "",
    phone: "",
  })
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState([])
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)

  const onSubmit = (event) => {
    event.preventDefault()
    setLoading(true)
    recaptchaRef.current.execute()
  }
  const onReCAPTCHAChange = async (captchaCode) => {
    if (!captchaCode) {
      return
    }
    setError(false)
    const service = gallery
      ? nodeApiService.contactGallery(gallery.id, {
          ...form,
          captcha: captchaCode,
          channel: "discover",
          type: "contact_discover",
        })
      : nodeApiService.contact({ ...form, captcha: captchaCode })
    service.then(
      (_response) => {
        console.log(_response)
        formCallback()
      },
      (res) => {
        setError(true)
        setErrorMessage(res.response.data.errorMessage)
        windowService.animatedScrollTop()
        setLoading(false)
      },
    )
    recaptchaRef.current.reset()
  }
  const formCallback = () => {
    windowService.animatedScrollTop()
    setSuccess(true)
    setLoading(false)
    setForm({
      email: "",
      firstname: "",
      lastname: "",
      body: "",
      phone: "",
    })
  }
  const handleClose = () => {
    setModal(false)
    setTimeout(() => {
      setSuccess(false)
    }, 500)
  }
  const handleShow = () => {
    setSuccess(false)
    setModal(true)
  }

  return {
    error,
    errorMessage,
    form,
    setForm,
    modal,
    handleClose,
    handleShow,
    onSubmit,
    success,
    onReCAPTCHAChange,
    recaptchaRef,
    loading,
  }
}
